import { hasApiAccess } from "@/lib/auth/access";
import type { UserPlan } from "@/lib/auth/plans";

/**
 * Whether /account shows the way to the API dashboard: for a viewer with API
 * access (Studio, or an admin on any plan). Everyone else sees the API in the
 * Studio card's highlights instead. The header's Agentic button follows the
 * same rule.
 */
export function apiCardFor(plan: UserPlan, email: string | null | undefined): "dashboard" | null {
  return hasApiAccess(plan, email) ? "dashboard" : null;
}
